export default function (value, set) {
    return set.includes(value)
};